import { Routes, Route } from 'react-router-dom'
import { Box, Link } from '@mui/material'
import { Header, Footer } from '@/components/layout'
import {
  HomePage,
  ServicesPage,
  WhyUsPage,
  PricingPage,
  FaqPage,
  ContactPage,
} from '@/pages'

/**
 * Main App Component
 * Routing configuration with header and footer layout
 */
function App() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Skip to main content link for keyboard navigation */}
      <Link
        href="#main-content"
        sx={{
          position: 'absolute',
          left: '-9999px',
          zIndex: 9999,
          padding: '1rem',
          backgroundColor: 'primary.main',
          color: 'white',
          textDecoration: 'none',
          fontWeight: 600,
          '&:focus': {
            left: '1rem',
            top: '1rem',
          },
        }}
      >
        Skip to main content
      </Link>

      {/* Header with navigation */}
      <Header />

      {/* Main content area with routes */}
      <Box component="main" id="main-content" sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/why-us" element={<WhyUsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  )
}

export default App
